/**
 * =========================================================
 * HM-FILTERS:JS
 * Gedeeld gedrag voor Huismerken.nl filters:
 * - prijs-sliders
 * - mobiele filterknop inklappen/uitklappen
 * - live telling op mobiel
 * - laadstatus bij submit
 * =========================================================
 */

(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function clamp(value, min, max) {
    value = Number(value);

    if (Number.isNaN(value)) value = min;
    if (value < min) value = min;
    if (value > max) value = max;

    return value;
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  /**
   * =========================================================
   * HM-FILTERS:PRICE-SLIDER-JS
   * Eén functie voor alle prijs-sliders.
   * =========================================================
   */

  function initPriceSliders(config) {
    var sliders = document.querySelectorAll(config.root);

    sliders.forEach(function (slider) {
      var minRange = slider.querySelector(config.minRange);
      var maxRange = slider.querySelector(config.maxRange);
      var minInput = slider.querySelector(config.minInput);
      var maxInput = slider.querySelector(config.maxInput);
      var minDisplay = slider.querySelector(config.minDisplay);
      var maxDisplay = slider.querySelector(config.maxDisplay);
      var rangeWrap = slider.querySelector(config.rangeWrap);

      if (!minRange || !maxRange || !minInput || !maxInput || !rangeWrap) return;

      var defaultMin = Number(slider.dataset.defaultMin) || 0;
      var defaultMax = Number(slider.dataset.defaultMax) || 0;

      function updateVisuals(minValue, maxValue) {
        var range = defaultMax - defaultMin || 1;
        var left = ((minValue - defaultMin) / range) * 100;
        var right = 100 - ((maxValue - defaultMin) / range) * 100;

        rangeWrap.style.setProperty('--hm-range-left', left + '%');
        rangeWrap.style.setProperty('--hm-range-right', right + '%');

        if (minDisplay) minDisplay.textContent = Math.round(minValue);
        if (maxDisplay) maxDisplay.textContent = Math.round(maxValue);
      }

      function updateFromRanges() {
        var minValue = clamp(minRange.value, defaultMin, defaultMax);
        var maxValue = clamp(maxRange.value, defaultMin, defaultMax);

        if (minValue > maxValue) {
          minValue = maxValue;
          minRange.value = minValue;
        }

        minInput.value = minValue > defaultMin ? Math.round(minValue) : '';
        maxInput.value = maxValue < defaultMax ? Math.round(maxValue) : '';

        updateVisuals(minValue, maxValue);
      }

      function updateFromInputs() {
        var minValue = minInput.value === '' ? defaultMin : clamp(minInput.value, defaultMin, defaultMax);
        var maxValue = maxInput.value === '' ? defaultMax : clamp(maxInput.value, defaultMin, defaultMax);

        if (minValue > maxValue) {
          minValue = maxValue;
          minInput.value = Math.round(minValue);
        }

        minRange.value = minValue;
        maxRange.value = maxValue;

        updateVisuals(minValue, maxValue);
      }

      updateVisuals(Number(minRange.value), Number(maxRange.value));

      minRange.addEventListener('input', updateFromRanges);
      maxRange.addEventListener('input', updateFromRanges);
      minInput.addEventListener('input', updateFromInputs);
      maxInput.addEventListener('input', updateFromInputs);
    });
  }

  /**
   * =========================================================
   * HM-FILTERS:MOBILE-DRAWER-JS
   * Mobiele filterknop inklappen/uitklappen.
   * =========================================================
   */

  function initMobileCollapse(config) {
    var fullBar = document.querySelector(config.fullBar);
    var miniBar = document.querySelector(config.miniBar);
    var hideButton = document.querySelector(config.hideButton);
    var expandButton = document.querySelector(config.expandButton);

    if (!fullBar || !miniBar || !hideButton || !expandButton) return;

    function setCollapsed(isCollapsed) {
      if (isCollapsed) {
        fullBar.classList.add('hm-is-hidden');
        miniBar.classList.add('hm-is-visible');
        safeStorageSet(config.storageKey, 'true');
      } else {
        fullBar.classList.remove('hm-is-hidden');
        miniBar.classList.remove('hm-is-visible');
        safeStorageSet(config.storageKey, 'false');
      }
    }

    if (safeStorageGet(config.storageKey) === 'true') {
      setCollapsed(true);
    }

    hideButton.addEventListener('click', function () {
      setCollapsed(true);
    });

    expandButton.addEventListener('click', function () {
      setCollapsed(false);
    });
  }

  /**
   * =========================================================
   * HM-FILTERS:MOBILE-COUNT-JS
   * Live telling voor collectie mobiel.
   * =========================================================
   */

  function initCollectionMobilePreview() {
    var form = document.querySelector('.hm-mobile-filter-form');

    if (!form) return;

    var applyButton = form.querySelector('.hm-mobile-apply');
    var miniCount = document.querySelector('.hm-mobile-filter-mini__count');
    var barSub = document.querySelector('.hm-mobile-filter-button__sub');

    var previewTimer = null;
    var previewAbort = null;

    function buildPreviewUrl() {
      var formData = new FormData(form);
      var params = new URLSearchParams();

      formData.forEach(function (value, key) {
        if (!key) return;
        if (value === null || value === '') return;

        params.append(key, value);
      });

      var queryString = params.toString();

      return form.action + (queryString ? '?' + queryString : '');
    }

    function extractCountFromText(text) {
      if (!text) return null;

      var cleanText = text.replace(/\s+/g, ' ').trim();
      var match = cleanText.match(/([\d.,]+)\s+van\s+[\d.,]+\s+producten/i);

      if (!match) {
        match = cleanText.match(/([\d.,]+)\s+producten/i);
      }

      if (!match || !match[1]) return null;

      return match[1].trim();
    }

    function updateButtonCount(count) {
      if (!count || !applyButton) return;

      applyButton.textContent = 'Toon ' + count + ' producten';

      if (miniCount) {
        miniCount.textContent = count;
      }

      if (barSub) {
        barSub.textContent = count + ' producten geselecteerd';
      }
    }

    function updatePreviewCount() {
      if (!applyButton) return;

      window.clearTimeout(previewTimer);

      previewTimer = window.setTimeout(function () {
        applyButton.textContent = 'Even tellen…';

        if (previewAbort) {
          previewAbort.abort();
        }

        previewAbort = new AbortController();

        fetch(buildPreviewUrl(), {
          method: 'GET',
          signal: previewAbort.signal,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            var possibleTexts = [
              doc.querySelector('.hm-mobile-filter-button__sub') ? doc.querySelector('.hm-mobile-filter-button__sub').textContent : '',
              doc.querySelector('.hm-mobile-filter-head span') ? doc.querySelector('.hm-mobile-filter-head span').textContent : '',
              doc.querySelector('.hm-mobile-apply') ? doc.querySelector('.hm-mobile-apply').textContent : ''
            ];

            var count = null;

            possibleTexts.some(function (text) {
              count = extractCountFromText(text);
              return Boolean(count);
            });

            if (count) {
              updateButtonCount(count);
            } else {
              applyButton.textContent = 'Toon producten';
            }
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;

            applyButton.textContent = 'Toon producten';
          });
      }, 300);
    }

    var previewInputs = form.querySelectorAll('input[type="checkbox"], input[type="range"], input[type="number"], select');

    previewInputs.forEach(function (input) {
      input.addEventListener('change', updatePreviewCount);
    });

    form.addEventListener('submit', function () {
      if (applyButton) {
        applyButton.textContent = 'Even laden…';
        applyButton.disabled = true;
      }

      form.classList.add('hm-is-calculating');
    });
  }

  /**
   * =========================================================
   * HM-FILTERS:SEARCH-MOBILE-COUNT-JS
   * Live telling voor zoekresultaten mobiel.
   * =========================================================
   */

  function initSearchMobilePreview() {
    var form = document.querySelector('.hm-search-mobile-filter-form');

    if (!form) return;

    var applyButton = form.querySelector('.hm-search-mobile-apply');
    var miniCount = document.querySelector('.hm-search-mobile-filter-mini__count');
    var barSub = document.querySelector('.hm-search-mobile-filter-button__sub');

    var previewTimer = null;
    var previewAbort = null;

    function buildPreviewUrl() {
      var formData = new FormData(form);
      var params = new URLSearchParams();

      formData.forEach(function (value, key) {
        if (!key || value === null || value === '') return;
        params.append(key, value);
      });

      var queryString = params.toString();

      return form.action + (queryString ? '?' + queryString : '');
    }

    function updateButtonCount(count) {
      if (!count || !applyButton) return;

      applyButton.textContent = 'Toon ' + count + ' resultaten';

      if (miniCount) {
        miniCount.textContent = count;
      }

      if (barSub) {
        barSub.textContent = count + ' resultaten geselecteerd';
      }
    }

    function updatePreviewCount() {
      if (!applyButton) return;

      window.clearTimeout(previewTimer);

      previewTimer = window.setTimeout(function () {
        applyButton.textContent = 'Even tellen…';

        if (previewAbort) {
          previewAbort.abort();
        }

        previewAbort = new AbortController();

        fetch(buildPreviewUrl(), {
          method: 'GET',
          signal: previewAbort.signal,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var countNode = doc.querySelector('[data-hm-search-result-count]');

            if (!countNode) {
              applyButton.textContent = 'Toon resultaten';
              return;
            }

            var count = countNode.getAttribute('data-hm-search-result-count');

            if (count) {
              updateButtonCount(count);
            } else {
              applyButton.textContent = 'Toon resultaten';
            }
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            applyButton.textContent = 'Toon resultaten';
          });
      }, 300);
    }

    var previewInputs = form.querySelectorAll('input[type="checkbox"], input[type="range"], input[type="number"], select');

    previewInputs.forEach(function (input) {
      input.addEventListener('change', updatePreviewCount);
    });

    form.addEventListener('submit', function () {
      if (applyButton) {
        applyButton.textContent = 'Even laden…';
        applyButton.disabled = true;
      }

      form.classList.add('hm-is-calculating');
    });
  }
/**
 * =========================================================
 * HM-FILTERS:COLOR-GROUPS-JS
 * Laat één zichtbare hoofdkleur meerdere echte Shopify
 * filterwaarden meesturen.
 * =========================================================
 */

function initColorGroups() {
  function syncColorGroup(master) {
    var group = master.getAttribute('data-hm-color-group');
    var root = master.closest('[data-hm-color-group-root]');

    if (!group || !root) return;

    var children = root.querySelectorAll(
      '[data-hm-color-group-child][data-hm-color-group="' + group + '"]'
    );

    children.forEach(function (child) {
      child.checked = master.checked;
      child.disabled = !master.checked;
    });
  }

  document.querySelectorAll('[data-hm-color-group-master]').forEach(function (master) {
    syncColorGroup(master);
  });

  document.addEventListener('change', function (event) {
    var master = event.target.closest('[data-hm-color-group-master]');

    if (!master) return;

    syncColorGroup(master);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form');

    if (!form) return;

    form.querySelectorAll('[data-hm-color-group-master]').forEach(function (master) {
      syncColorGroup(master);
    });
  }, true);
}
  /**
   * =========================================================
   * HM-FILTERS:SUBMIT-JS
   * Simpele laadstatus voor desktop zoekfilter.
   * =========================================================
   */

  function initDesktopSearchSubmitState() {
    var form = document.querySelector('.hm-search-desktop-filter-bar');

    if (!form) return;

    form.addEventListener('submit', function () {
      var buttons = form.querySelectorAll('button[type="submit"]');

      buttons.forEach(function (button) {
        button.textContent = 'Even laden…';
        button.disabled = true;
      });
    });
  }

  /**
   * =========================================================
   * Init
   * =========================================================
   */

  onReady(function () {
    initPriceSliders({
      root: '[data-hm-price-slider]',
      minRange: '[data-hm-price-min-range]',
      maxRange: '[data-hm-price-max-range]',
      minInput: '[data-hm-price-min-input]',
      maxInput: '[data-hm-price-max-input]',
      minDisplay: '[data-hm-price-min-display]',
      maxDisplay: '[data-hm-price-max-display]',
      rangeWrap: '.hm-price-slider__range-wrap'
    });

    initPriceSliders({
      root: '[data-hm-mobile-price-slider]',
      minRange: '[data-hm-mobile-price-min-range]',
      maxRange: '[data-hm-mobile-price-max-range]',
      minInput: '[data-hm-mobile-price-min-input]',
      maxInput: '[data-hm-mobile-price-max-input]',
      minDisplay: '[data-hm-mobile-price-min-display]',
      maxDisplay: '[data-hm-mobile-price-max-display]',
      rangeWrap: '.hm-mobile-price-slider__range-wrap'
    });

    initPriceSliders({
      root: '[data-hm-search-price-slider]',
      minRange: '[data-hm-search-price-min-range]',
      maxRange: '[data-hm-search-price-max-range]',
      minInput: '[data-hm-search-price-min-input]',
      maxInput: '[data-hm-search-price-max-input]',
      minDisplay: '[data-hm-search-price-min-display]',
      maxDisplay: '[data-hm-search-price-max-display]',
      rangeWrap: '.hm-search-price-slider__range-wrap'
    });

    initPriceSliders({
      root: '[data-hm-search-mobile-price-slider]',
      minRange: '[data-hm-search-mobile-price-min-range]',
      maxRange: '[data-hm-search-mobile-price-max-range]',
      minInput: '[data-hm-search-mobile-price-min-input]',
      maxInput: '[data-hm-search-mobile-price-max-input]',
      minDisplay: '[data-hm-search-mobile-price-min-display]',
      maxDisplay: '[data-hm-search-mobile-price-max-display]',
      rangeWrap: '.hm-search-mobile-price-slider__range-wrap'
    });

    initMobileCollapse({
      fullBar: '[data-hm-mobile-filter-bar]',
      miniBar: '[data-hm-mobile-filter-mini]',
      hideButton: '[data-hm-mobile-filter-hide]',
      expandButton: '[data-hm-mobile-filter-expand]',
      storageKey: 'hmMobileFilterCollapsed'
    });

    initMobileCollapse({
      fullBar: '[data-hm-search-mobile-filter-bar]',
      miniBar: '[data-hm-search-mobile-filter-mini]',
      hideButton: '[data-hm-search-mobile-filter-hide]',
      expandButton: '[data-hm-search-mobile-filter-expand]',
      storageKey: 'hmSearchMobileFilterCollapsed'
    });

 initCollectionMobilePreview();
initSearchMobilePreview();
initColorGroups();
initDesktopSearchSubmitState();
  });
})();